module.exports = __webpack_public_path__ + "media/audio1.cec07651.mp3";